module.exports = __webpack_public_path__ + "static/media/bootcampElements.d7f54dc4.png";